import { Grid, TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { showPopupSnackbar } from "../redux/actions/snackbarActions";
import { getToken } from "../Utils/Common";
import EnvSettings from "../Utils/EnvSettings";

const server = EnvSettings.server;

export default function User(props) {
  const { t } = useTranslation();
  const [user, setUser] = useState();
  const [companies, setCompanies] = useState();
  const dispatch = useDispatch();

  let ref = React.useRef();

  useEffect(() => {
    const getUser = () => {
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          token: getToken(),
          userid: props.computedMatch.params.user_id,
        }),
      };
      fetch(server + "/get_user", requestOptions)
        .then((res) => res.json())
        .then((result) => {
          if (process.env.NODE_ENV !== "production") {
            console.log(result);
          }
          if (result.error) {
            dispatch(showPopupSnackbar(result));
          } else {
            setUser(result.user);
          }
        });
    };

    const getCompanies = () => {
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token: getToken() }),
      };
      fetch(server + "/get_companies", requestOptions)
        .then((res) => res.json())
        .then((result) => {
          if (process.env.NODE_ENV !== "production") {
            console.log(result);
          }
          if (result.error) {
            dispatch(showPopupSnackbar(result));
          } else {
            setCompanies(result.companies);
          }
        });
    };

    getUser();
    getCompanies();
  }, [dispatch, props.computedMatch.params.user_id]);

  return user ? (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={6}>
        <TextField
          name="userName"
          variant="outlined"
          disabled
          fullWidth
          id="userName"
          label={t("newUser.username")}
          value={user.userName}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          autoComplete="fname"
          name="fullName"
          variant="outlined"
          required
          fullWidth
          id="fullName"
          label={t("newUser.firstName")}
          value={user.fullName}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          variant="outlined"
          required
          fullWidth
          id="email"
          label={t("newUser.email")}
          name="email"
          autoComplete="email"
          value={user.emailAddress}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        {companies ? (
          <Autocomplete
            id="combo-box"
            options={companies}
            defaultValue={user.Company}
            getOptionLabel={(option) => option.companyName}
            //style={{ width: 300 }}
            renderInput={(params) => (
              <TextField
                {...params}
                label={t("newUser.company")}
                ref={ref}
                variant="outlined"
              />
            )}
          />
        ) : undefined}
      </Grid>
    </Grid>
  ) : null;
}
